import React from 'react';
import { decrypt, URL } from '../variables';
import CandidateLanguageSelector from '../components/CandidateLanguageSelector';
import { getLanguageTexts,languageOptions, getSelectedLanguage,setSelectedLanguage } from '../language';

class SelectFaculdade extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      faculdades: [],
      faculdade_select: 'tete',
      loading: false,
      msgErro: '',
      redirect: false,
      selectedLanguage: getSelectedLanguage()
    }
  }

     handleLanguageChange(event) {
         this.setState({ selectedLanguage: setSelectedLanguage(event.target.value) });
     }

  change_faculdade(event) {
    this.setState({ faculdade_select: event.target.value });

  }

  // renderRedirect = () => {
  //   if (this.state.redirect) {
  //     return <Redirect to={'/'+this.state.faculdade_select.slug} />
  //   }
  // }

  get_faculdades() {
    fetch(`${URL}api/get_faculdades?v=a`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',

        // 'Authorization': `Bearer ${this.props.token}`,
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        resp = decrypt(resp);
        console.log(resp);
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
              erro += errors[i] + '\n';
            else
              erro += errors[i];
          }
          console.log(erro);

          this.setState({ loading: false, msgErro: erro, refresh: false, loadingMore: false });
        }
        else {
          let selected = '';
          if (resp.faculdades.length > 0) {

            selected = resp.faculdades[0].slug;
          }
          this.setState({ faculdades: resp.faculdades, loading: false, msgErro: '', faculdade_select: selected });
          // this.setState({ loading: false, refresh: false, loadingMore: false, msgErro: '' });

        }




      } catch (err) {
        console.log(err);
        this.setState({ loading: false, msgErro: getLanguageTexts(this.state.selectedLanguage).server_response_error, refresh: false, loadingMore: false });

      }

    })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false, msgErro: getLanguageTexts(this.state.selectedLanguage).internet_connection_error, refresh: false, loadingMore: false });
      });
  }

   handleLanguageEvent(event) {
          this.setState({ selectedLanguage: event.detail || getSelectedLanguage() });
      }

  componentDidMount() {
    window.addEventListener('candidate_language_change', this.handleLanguageEvent.bind(this));
    this.setState({ loading: true, msgErro: '' });
    this.get_faculdades();
  }

  componentWillUnmount() {
    window.removeEventListener('candidate_language_change', this.handleLanguageEvent.bind(this));
  }






  render() {
    const t = getLanguageTexts(this.state.selectedLanguage);
    return (
      <div className="candidate-select-page">
        {this.state.loading && <div className="candidate-auth-loading"> <div className="spinner-border text-primary" role="status"  >
          <span className="sr-only">{t.loading}</span>
        </div></div>}
        {this.state.loading==false && <div id="app" className="candidate-select-shell">
          <header className="candidate-select-header" style={{justifyContent:'space-between'}}>
              <img src={require('../assets/images/logo-ontest.png')} alt="OnTest" />
              <ul className="navbar-right d-flex list-inline float-right mb-0">
                                      <li className="candidate-header-language">
                                          <i className="mdi mdi-web"></i>
                                          <select value={this.state.selectedLanguage} onChange={this.handleLanguageChange.bind(this)}>
                                              {languageOptions.map((item) => (
                                                  <option key={item.value} value={item.value}>{item.value}</option>
                                              ))}
                                          </select>
                                      </li>
              
              
                                  </ul>
          </header>

          <main className="candidate-select-main">
            <section className="candidate-select-card">
              <div className="candidate-select-copy">
                <span className="candidate-auth-kicker">{t.evaluation_access}</span>
                <h1>{t.choose_institution}</h1>
                <p>{t.select_institution_hint}</p>
              </div>

              <div className="candidate-select-list">
                {this.state.faculdades.map((item,id)=>(
                  <a key={id} href={'/' + item.slug + '/login'} className="candidate-select-item">
                    <div className="candidate-select-logo">
                      <img src={item.logo} alt={item.name} />
                    </div>
                    <div className="candidate-select-info">
                      <strong>{item.name}</strong>
                      <span>{t.access_candidate_environment}</span>
                    </div>
                    <span className="candidate-select-action" aria-hidden="true">
                      <i className="mdi mdi-arrow-right"></i>
                    </span>
                  </a>
                ))}
                {this.state.faculdades.length == 0 && <div className="candidate-select-empty">
                  <i className="mdi mdi-school-outline"></i>
                  <strong>{t.no_institution_available}</strong>
                  <span>{t.try_again_later}</span>
                </div>}
              </div>
            </section>
          </main>
        </div>}
      </div>
    );
  }


}

export default SelectFaculdade;
